var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6298 5.58721H16.1185C16.0283 5.5874 15.9412 5.6206 15.8731 5.68069L13.151 8.10677C13.1094 8.0178 13.0662 7.92884 13.0172 7.8429C12.5822 7.057 11.939 6.41036 11.1603 5.97622C10.356 5.51936 9.37915 5.28564 8.25518 5.28564H8.20909C7.08513 5.28564 6.10685 5.51936 5.30551 5.97622C4.52481 6.41091 3.88072 7.05996 3.4471 7.84893C3.01896 8.63308 2.79724 9.51588 2.80335 10.4122V19.346H5.33078V10.4122C5.32635 10.0316 5.39728 9.65388 5.53936 9.30153C5.68146 8.94919 5.89182 8.62934 6.15799 8.36093C6.42417 8.09253 6.74074 7.88103 7.08898 7.73895C7.43721 7.59687 7.81001 7.52711 8.18531 7.5338H8.27748C8.77693 7.52508 9.26958 7.65205 9.70433 7.90153C10.1391 8.15103 10.5001 8.51395 10.7499 8.95265C11.0037 9.39562 11.1347 9.89993 11.129 10.4122V19.346H13.6565V10.9867L18.6073 6.57634C18.674 6.517 18.7562 6.4784 18.844 6.46514C18.9317 6.45189 19.0215 6.46454 19.1023 6.50159C19.1833 6.53863 19.2519 6.5985 19.3001 6.67406C19.3484 6.7496 19.3742 6.83764 19.3744 6.92765V19.3385H22V5.96265C21.9996 5.8632 21.9604 5.76793 21.8911 5.69761C21.8218 5.62729 21.7279 5.5876 21.6298 5.58721Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMLetter);
export default __webpack_public_path__ + "static/media/m-letter.819ea67eacbda2fb3b1b2e2711c6d1c7.svg";
export { ForwardRef as ReactComponent };